import { css } from "@emotion/react";
import { Images } from "../../common/images";

export const tableStyle = css`
  overflow: auto;

  .ant-table-body {
    height: calc(100vh - 381px);
  }

  td,
  th {
    overflow: hidden;
    vertical-align: top;
  }

  .ant-table-thead > tr > th {
    font-weight: bold;
  }
`;

export const iconStyle = css`
  height: 18px;
  margin-right: 20px;
`;

export const swatchPreviewStyle = css`
  height: 80px;
`;

export const checkboxGroupStyle = css`
  margin-left: 28px;
  > label {
    display: flex;
  }
`;

export const iconSuccessStyle = css`
  background: url(${Images.CHECK_BLUE});
  width: 24px;
  height: 24px;
`;

export const notificationButonStyle = css`
  height: 28px;
  padding: 0px 8px;
  border-width: 2px;
  font-size: 14px;
  line-height: 14px;
  margin-left: 10px;

  > .ico-check-white,
  > .ico-undo {
    width: 14px;
    height: 14px;
    display: inline-block;
  }

  > .ico-check-white {
    background: url(${Images.CHECK_WHITE});
  }

  > .ico-undo {
    background: url(${Images.UNDO_BLACK});
  }
`;

export const singleTextLineStyle = css`
  width: 100%;
  margin-bottom: 0px !important;
`;

export const formInputStyle = css`
  margin-bottom: 0px !important;
`;

export const flexEndStyle = css`
  text-align: right;
`;
